export const formattingSlashItems = [
  {
    title: 'Paragraph',
    description: 'Plain text paragraph',
    icon: '¶',
    group: 'Format',
    keywords: ['paragraph', 'text', 'plain', 'normal'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setParagraph().run();
    },
  },
  {
    title: 'Heading',
    description: 'Large section heading',
    icon: 'H1',
    group: 'Format',
    keywords: ['heading', 'h1', 'title', 'large'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleHeading({ level: 1 }).run();
    },
  },
  {
    title: 'Subheading',
    description: 'Medium section heading',
    icon: 'H2',
    group: 'Format',
    keywords: ['subheading', 'h2', 'subtitle', 'medium'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleHeading({ level: 2 }).run();
    },
  },
  {
    title: 'Blockquote',
    description: 'Indented quote block',
    icon: '"',
    group: 'Format',
    keywords: ['blockquote', 'quote', 'indent'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleBlockquote().run();
    },
  },
  {
    title: 'Code',
    description: 'Inline code',
    icon: '</>',
    group: 'Format',
    keywords: ['code', 'inline', 'monospace', 'backtick'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleCode().run();
    },
  },
  {
    title: 'Bullet List',
    description: 'Unordered list with bullet points',
    icon: '•',
    group: 'Format',
    keywords: ['bullet', 'list', 'unordered', 'ul'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleBulletList().run();
    },
  },
  {
    title: 'Ordered List',
    description: 'Numbered list',
    icon: '1.',
    group: 'Format',
    keywords: ['ordered', 'list', 'numbered', 'ol', 'number'],
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleOrderedList().run();
    },
  },
];
